/* ============================================================================
 * Project        : Deloitte Digital Compliance
 * File           : typeApprovalReducer.js
 * Version        : 1.0.0
 * Author         : Team Neubinary
 * Created On     : 2026-06-24
 *
 * Description    : Digital Compliance for Automation and Governance
 *
 * Change History :
 * ----------------------------------------------------------------------------
 * Date         | Version | Author           | Description
 * ----------------------------------------------------------------------------
 * 2026-06-24   | 1.0.0   | Team Neubinary   | Initial creation
 * <YYYY-MM-DD> | x.x.x   | <Name/Team>      | <Change description>
 * ============================================================================
 *
 * Copyright (c) 2026 AU79 Consulting Services Pvt. Ltd.
 * All Rights Reserved.
 *
 * This source code and its contents are confidential and proprietary to
 * AU79 Consulting Services Pvt. Ltd. Unauthorized copying, reproduction,
 * modification, distribution, or disclosure of this material, in whole or
 * in part, is strictly prohibited without prior written permission from
 * AU79 Consulting Services Pvt. Ltd.
 * ============================================================================
 */
import customConsole from "../../config/customConsole";
import actionType from "../actionTypes";

const initialState = {
  error: false,
  msg: "",
  typeApproval: [],
  cTypeApproval: [],
};

const typeApprovalReducer = (state = initialState, action) => {
  customConsole(action);
  switch (action.type) {
    case actionType.GET_CREATE_INTERSECTIONS:
      return {
        ...state,
        error: action.payload.error,
        msg: action.payload.msg,
        cTypeApproval: action.payload.error
          ? []
          : action.payload.data.intersections,
      };
    case actionType.CREATE_INTERSECTIONS:
      return {
        ...state,
        error: action.payload.error,
        msg: action.payload.msg,
      };
    // case actionType.GET_TICKETS:
    //   return {
    //     ...state,
    //     error: action.payload.error,
    //     msg: action.payload.msg,
    //     typeApproval: action.payload.error ? [] : action.payload.data,
    //   };

    case actionType.UPDATE_PROJECT_STATUS_TICKETS:
      return {
        ...state,
        error: action.payload.error,
        msg: action.payload.msg,
      };
    case actionType.RE_CREATE_TICKETS:
      return {
        ...state,
        error: action.payload.error,
        msg: action.payload.msg,
      };
    case actionType.DELETE_DRAFT_TICKETS:
      return {
        ...state,
        error: action.payload.error,
        msg: action.payload.msg,
      };
    case actionType.RESET_TYPE_APPROVAL:
      return initialState;
    default:
      return state;
  }
};

export default typeApprovalReducer;
